import { render, staticRenderFns } from "./OrdersTableEmpty.vue?vue&type=template&id=2529a58b&scoped=true"
import script from "./OrdersTableEmpty.vue?vue&type=script&lang=js"
export * from "./OrdersTableEmpty.vue?vue&type=script&lang=js"
import style0 from "./OrdersTableEmpty.vue?vue&type=style&index=0&id=2529a58b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529a58b",
  null
  
)

export default component.exports